import { render, staticRenderFns } from "./MonsterView2.vue?vue&type=template&id=c927111e&scoped=true&"
import script from "./MonsterView2.vue?vue&type=script&lang=ts&"
export * from "./MonsterView2.vue?vue&type=script&lang=ts&"
import style0 from "./MonsterView2.vue?vue&type=style&index=0&id=c927111e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c927111e",
  null
  
)

export default component.exports